import { CIDADAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import image from 'images/gestao-cadastros/mudanca-cadastro-individual.svg'
import MudancaPathRedirectView from 'view/gestao-cadastros/MudancaPathRedirectView'

export default function CidadaoRedirectView() {
  return (
    <MudancaPathRedirectView
      titulo='O cadastro individual mudou de lugar!'
      texto='Agora você pode acessar o cadastro individual na seção de Gestão de cadastros do menu principal.'
      textoBotao='Acessar Cadastro individual'
      path={CIDADAO_PATH}
      image={image}
    />
  )
}
